import { Navigate } from "react-router-dom";
import { MiamiFlow } from "@/pages/MiamiPage";
import { getCityContent } from "@/data/localCityConfig";

export default function LocalCityPage({ city, lang }) {
  const content = getCityContent(city, lang);
  if (!content) return <Navigate to="/" replace />;
  return (
    <MiamiFlow
      industries={content.industries}
      buckets={content.buckets}
      questions={content.questions}
      example={content.example}
      getIndustryFn={content.getIndustryFn}
      copy={content.copy}
      source={content.source}
      market={content.market}
    />
  );
}
